import React from "react";
import { GraduationCap } from "lucide-react";

export default function BrandLogo({ subtitle = "One Platform. Every School Operation." }) {
  return (
    <div className="flex items-start gap-3" data-testid="brand-logo">
      <div className="h-11 w-11 rounded-2xl bg-primary/95 grid place-items-center shadow-lg shadow-primary/30">
        <GraduationCap className="h-6 w-6 text-primary-foreground" strokeWidth={2.2} />
      </div>
      <div>
        <div className="text-lg font-bold tracking-tight text-foreground">
          School OS<sup className="text-[0.55em] ml-0.5 opacity-70">™</sup>
        </div>
        {subtitle ? <div className="text-xs text-muted-foreground max-w-[220px] leading-tight">{subtitle}</div> : null}
      </div>
    </div>
  );
}
